import React from 'react';
import { trim } from 'lodash';
import classNames from 'classnames';
import { CHATBOT_TEST_IDS } from 'modules/chatbot/constants/testIds';

import styles from './userMessageBubble.module.less';

type UserMessageBubbleProps = {
  content?: string;
  messageId?: string;
};

const UserMessageBubble: React.FC<UserMessageBubbleProps> = ({
  content,
  messageId,
}: UserMessageBubbleProps) => {
  return (
    <div
      className={classNames(
        styles.chatBubble,
        styles.userBubble,
        styles.userBubbleMaxWidth,
        styles.bubblePadding
      )}
      data-testid={CHATBOT_TEST_IDS.USER_MESSAGE}
      data-message-id={messageId}
    >
      <div
        className={styles.layoutWrapper}
        data-testid={CHATBOT_TEST_IDS.USER_MESSAGE_LAYOUT}
      >
        <div
          className={styles.content}
          data-testid={CHATBOT_TEST_IDS.USER_MESSAGE_CONTENT}
        >
          {trim(content || '')}
        </div>
      </div>
    </div>
  );
};

export default UserMessageBubble;
